module.exports = __webpack_public_path__ + "img/all_new.1c8bdf5f.webp";